/**
 * Texts for Library page
 */
export const libraryPageText = {
    title: 'CamAPS Liberty - CamAPS FX',
    titleMeta: 'CamAPS Liberty - CamAPS FX',
    descriptionMeta: 'Toegang tot bronnen en ondersteuningsmaterialen voor CamAPS FX en CamAPS Liberty®.',
    keywords: 'camaps bibliotheek, camaps fx, camaps liberty, ondersteuning bronnen, diabetesbeheer',
    localeMeta: 'nl_nl',

    bannerTitle: 'Ondersteuning voorbij de cijfers',
    bannerSubtitle: 'met CamAPS Liberty<sup>®</sup>',
    bannerDescription: 'Wanneer geactiveerd, hoeven gebruikers geen koolhydraten te tellen en geen pre-maaltijd insulinebolus toe te dienen.',
    bannerCompatibility: 'Compatibel met Android en iOS',
    
    announcementText: 'Nu beschikbaar in myLoop',
    announcementDisclaimer: '',

    introTitle: 'De eerste volledig gesloten-lusfunctie. Wanneer u die nodig hebt.',
    introDescription: 'Wanneer geactiveerd, hoeven gebruikers geen koolhydraten te tellen en geen pre-maaltijd insulinebolus toe te dienen.',
    introSubtext: 'Beschikbaar op Android- en Apple-besturingssystemen',

    howItWorksTitle: 'Hoe werkt het?',
    howItWorksDescription: 'Aangedreven door een proactievere versie van het CamAPS-algoritme. CamAPS Liberty anticipeert en reageert op glucoseveranderingen terwijl gevestigde veiligheidsgrenzen worden gehandhaafd.',
    
    step1Title: 'STAP 1',
    step1Description: 'Ga vanaf uw startscherm naar het instellingenmenu.',
    step2Title: 'STAP 2',
    step2Description: 'Scroll naar beneden en tik op de schakelaar om te activeren.',
    step3Title: 'STAP 3',
    step3Description: 'Bij het eerste gebruik moet u onze uitlegvideo over CamAPS Liberty bekijken.',
    step4Title: 'STAP 4',
    step4Description: 'Bevestig dat u niet jonger bent dan 13 jaar en niet zwanger bent.',
    step5Title: 'STAP 5',
    step5Description: 'Tik opnieuw op de schakelaar om te activeren.',
    step6Title: 'STAP 6',
    step6Description: "U bent klaar. Het CamAPS Liberty-tabblad verschijnt op uw startscherm<sup>†</sup>.",
    step6Footnote: "<sup>†</sup> Werkt alleen wanneer \"Auto mode\" is ingeschakeld",

    eligibilityTitle: 'Wie kan CamAPS Liberty gebruiken?',
    eligibilityCriterion1: 'Bestaande gebruikers met type 1 diabetes',
    eligibilityCriterion2: '13 jaar en ouder',
    eligibilityCriterion3: 'Zwanger',
    parentsCarersTitle: 'Hoe zit het met ouders en verzorgers?',
    parentsCarersBlockTitle: 'Functie \'Blokkering\':',
    parentsCarersBlockDescription: 'Om onbedoeld gebruik te voorkomen',
    parentsCarersRemoteTitle: 'Monitoring op afstand:',
    parentsCarersRemoteDescription: 'Companion, Glooko® en CamAPS 2-wekelijkse PDF-rapporten',
    
    imageOverlayText: 'Ontworpen om naast uw huidige diabetesbeheerplan te werken; niet om het te vervangen.',
    
    usingTitle: 'CamAPS Liberty gebruiken',
    
    treatmentPlanText: 'CamAPS Liberty is ontworpen om de noodzaak van routinematige maaltijdbolussen weg te nemen. De functie vervangt niet de andere onderdelen van het diabetesbehandelplan van de gebruiker, waaronder regelmatige evaluatie met het diabetesteam.',
    
    usingLibertyTitle: 'Bekijk en leer over CamAPS Liberty',
    usingLibertyDescription: 'Bekijk video\'s om meer te weten te komen over CamAPS Liberty en hoe u kunt beginnen.',
    // latestVideoLabel removed
    moreVideosLabel: 'Meer video\'s',
    factsheetDownloadText: 'CamAPS Liberty-factsheet (pdf)',
    factsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_nl.pdf',
    usingLibertyFeaturedVideo: {
        youtubeUrl: 'https://youtu.be/px9QSOhy544',
        title: 'CamAPS Liberty: Aan de slag',
        description: 'Candice Ward legt uit hoe u CamAPS Liberty instelt en gebruikt.',
        duration: '31:50',
        date: '15 Sep 2026',
    },
    usingLibertyMoreVideos: [
        {
            youtubeUrl: 'https://youtu.be/l1mxNqKdf7M',
            title: 'Praktische Tips: CamAPS Liberty',
            duration: '02:14',
        },
        {
            youtubeUrl: 'https://youtu.be/K7_j-Sk5Fas',
            title: 'Introductie van CamAPS Liberty',
            duration: '14:42',
        },
        {
            youtubeUrl: 'https://youtu.be/0dp5A8z_SEk',
            title: 'Dat fully closed-loop-gevoel',
            duration: '04:22',
        },
        {
            youtubeUrl: 'https://youtu.be/yF1w941g6d4',
            title: 'De CamAPS Liberty-functie',
            duration: '03:40',
        }
    ],
    
    whatHappensNextTitle: 'Wat gebeurt er daarna?',
    whatHappensNextText: 'We zullen in de komende maanden een pilot uitvoeren binnen een enkele markt. Blijf op de hoogte voor meer details.',
};

